/*
 *  微信小程序初始化操作
 */

import initWecharConfig, { WxMiniConfig } from "api/WechartHandle";
import React from "react";
import { withRouter } from 'react-router-dom';
import { isWechat } from "tools/utils/UA";

class WxMiniHandler extends React.PureComponent<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            wxConfigSuccess: false,
        }
    }

    componentDidMount() {
        // 微信小程序环境判断初始化成功后再加载页面
        const that = this;
        if (isWechat()) {
            // 初始化微信小程序权限验证配置
            initWecharConfig();
            try {
                window.wx.miniProgram.getEnv(function (res) {
                    that.setState({
                        wxConfigSuccess: true,
                    })
                    if (res.miniprogram) {
                        WxMiniConfig.newInstance().setAppkey('XCX001')
                    }
                });
            } catch (error) {
                that.setState({
                    wxConfigSuccess: true,
                })
            }
        } else {
            that.setState({
                wxConfigSuccess: true,
            })
        }
    }

    componentWillReceiveProps(nextProps: Readonly<any>, nextContext: any): void {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            setTimeout(() => {
                // 初始化微信小程序权限验证配置
                initWecharConfig();
            }, 0);
        }
    }

    render() {
        return <>{this.state.wxConfigSuccess && this.props.children}</>
    }
}

export default withRouter(WxMiniHandler);
